module.exports = __webpack_public_path__ + "assets/img/24_1072_big.4e751aab.jpg";